import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { modifier as modifierFn } from "ember-modifier";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";
import { humanKeyName } from "../lib/live/ptt-utils.js";

const RESERVED_KEYS = new Set(["Escape", "Tab", "Enter"]);

export default class LivePttKeyCapture extends Component {
  @tracked capturedKey = null;
  @tracked isReserved = false;

  autoFocus = modifierFn((element) => {
    element.focus();
  });

  get displayText() {
    if (this.isReserved) {
      return i18n("live.ptt.reserved_key");
    }
    if (this.capturedKey) {
      return humanKeyName(this.capturedKey);
    }
    return i18n("live.ptt.press_key");
  }

  @action
  onKeyDown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (RESERVED_KEYS.has(event.code)) {
      this.isReserved = true;
      this.capturedKey = null;
      return;
    }

    this.isReserved = false;
    this.capturedKey = event.code;
  }

  @action
  confirm() {
    if (this.capturedKey && !this.isReserved) {
      this.args.onConfirm?.(this.capturedKey);
    }
  }

  @action
  cancel() {
    this.args.onCancel?.();
  }

  <template>
    <div
      class="live-ptt-key-capture"
      tabindex="0"
      {{on "keydown" this.onKeyDown}}
      {{this.autoFocus}}
    >
      <span
        class="live-ptt-key-capture__display
          {{if this.isReserved 'live-ptt-key-capture__display--error'}}
          {{if this.capturedKey 'live-ptt-key-capture__display--captured'}}"
      >
        {{this.displayText}}
      </span>
      <div class="live-ptt-key-capture__actions">
        <DButton
          class="btn-flat btn-small live-ptt-key-capture__confirm"
          @action={{this.confirm}}
          @disabled={{if this.capturedKey false true}}
          @icon="check"
        />
        <DButton
          class="btn-flat btn-small live-ptt-key-capture__cancel"
          @action={{this.cancel}}
          @icon="xmark"
        />
      </div>
    </div>
  </template>
}
